<script lang="ts" setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { InvoiceStatusEnum } from "@/api/billing/dto/invoice";

const { t } = useI18n();

const props = withDefaults(
  defineProps<{
    status: InvoiceStatusEnum;
    isActive?: boolean;
  }>(),
  {
    isActive: true,
  },
);

const classes = computed<string>(() => {
  if (!props.isActive) {
    return "bg-grey-darken-3 text-white";
  }

  switch (props.status) {
    case InvoiceStatusEnum.Rated:
      return "bg-amber-lighten-2 text-grey-darken-3";
    case InvoiceStatusEnum.ReadyToPost:
      return "bg-indigo-lighten-1 text-white";
    case InvoiceStatusEnum.Posted:
      return "bg-indigo-darken-3 text-white";
    case InvoiceStatusEnum.Synced:
      return "bg-blue-grey-darken-1 text-white";
    case InvoiceStatusEnum.Generated:
    default:
      return "bg-grey-lighten-4 text-grey-darken-3";
  }
});
</script>

<template>
  <span :class="classes" class="invoice-status" data-qa="invoice-status">
    {{ t(`billing.statuses.${props.status}`) }}
  </span>
</template>

<style lang="scss" scoped>
.invoice-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
}
</style>
